module.exports = __webpack_public_path__ + "5c21051ab7825f4fa1b3222b6e66925d.png";